import React, { useState, useEffect } from "react";
import {
  ThinTextField,
  ThinDropdownWithSearch,
} from "../common/GeneralComponent";
import { fetchData } from "../../utils/functions";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom"
const GeneralInformation = ({ healthFacility }) => {

    const { id } = useParams();
    const navigate = useNavigate();

  const [formData, setFormData] = useState({
    facility_name: "",
    incharge_name: "",
    incharge_contact: "",
    facility_contact: "",
    facility_type: "",
    pharmacy: "",
    ownership: "",
    functional: "",
    staff_doctors: "",
    staff_lhvs: "",
    staff_dispensers: "",
    staff_vaccinators: "",
    staff_others: "",
    date_of_collection: null,
    health_status: "",
    latitude: "",
    longitude: "",
    total_staff: 0,
    facility_type_other: "",
    ownership_other: "",
    mission: "",
    uc_name: "", 
  });
  const [districts, setDistricts] = useState([]);
  const [tehsils, setTehsils] = useState([]);
  const [ucs, setUcs] = useState([]); 
  const [dehs, setDehs] = useState([]);
  const [villages, setVillages] = useState([]);

  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedDeh, setSelectedDeh] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");
  
  const [isDqaApproved, setIsDqaApproved] = useState(false);
   const [isDqaRejected, setIsDqaRejected] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [loader, setLoader] = useState(false);

  const [isUpdating, setIsUpdating] = useState(false);
  const [errors, setErrors] = useState({});
  const generateMissionOptions = () => {
    if (!selectedDeh) return [];

    const selectedDehData = dehs.find(
      (d) => d.deh_id.toString() === selectedDeh
    );
    if (!selectedDehData) return [];

    const dehName = selectedDehData.deh_name;
    const missions = [];

    for (let i = 1; i <= 25; i++) {
      const missionCode = `M${i.toString().padStart(2, "0")}`;
      missions.push({
        label: `${dehName}_${missionCode}`,
        value: `${dehName}_${missionCode}`,
      });
    }

    return missions;
  };

  const missionOptions = generateMissionOptions();

  const fetchHealthFacilityAssessment = async () => {
    try {
      setLoader(true);
      setIsFetching(true);

      const response = await fetchData(
        `health-fetchById/${id}`,
        "GET",
        null,
        {},
        {},
        navigate
      );

      if (response?.data) {
        // setSchoolData(response.data);
        const isDqaApproved =
          response.data?.healthFacility.verified_from_dqa === 1 ||
          response.data?.healthFacility.verified_from_dqa === "1";

        const isDqaRejected =
          response.data?.healthFacility.verified_from_dqa === 2 ||
          response.data?.healthFacility.verified_from_dqa === "2";
        setIsDqaRejected(isDqaRejected);

        setIsDqaApproved(isDqaApproved);
      }
    } catch (error) {
      console.error("Error fetching school data:", error);
      toast.error("Failed to load school data.");
    } finally {
      setLoader(false);
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchHealthFacilityAssessment();
  }, [id]);

  const validationSchema = Yup.object().shape({
    district_id: Yup.string().required("District is required"),
    tehsil_id: Yup.string().required("Taluka is required"),
    deh_id: Yup.string().required("Deh is required"),
    mission: Yup.string()
      .required("Mission is required")
      .max(200, "Mission cannot exceed 200 characters"),
    village_id: Yup.string().required("Village is required"),
    facility_name: Yup.string().required("Facility Name is required"),
    incharge_name: Yup.string().required("Incharge Name is required"),
    facility_contact: Yup.string()
      .matches(
        /^03\d{2}-?\d{7}$/,
        "Facility Contact must start with 03 and be 11 digits"
      )
      .required("Facility Contact is required"),

    incharge_contact: Yup.string()
      .matches(
        /^03\d{2}-?\d{7}$/,
        "Incharge Contact must start with 03 and be 11 digits"
      )
      .required("Incharge Contact is required"),

    facility_type: Yup.string().required("Facility Type is required"),
    pharmacy: Yup.string().required("Pharmacy Availability is required"),
    ownership: Yup.string().required("Ownership is required"),
    functional: Yup.string().required("Functional Status is required"),
    staff_doctors: Yup.number()
      .typeError("Doctors count must be a required")
      .min(0, "Value cannot be negative")
      .max(999, "Value cannot exceed 999")
      .required("Doctors count is required"),
    staff_lhvs: Yup.number()
      .typeError("LHVs count must be a required")
      .max(999, "Value cannot exceed 999")
      .min(0, "Value cannot be negative")
      .required("LHVs count is required"),
    staff_dispensers: Yup.number()
      .typeError("Dispensers count must be a required")
      .max(999, "Value cannot exceed 999")
      .min(0, "Value cannot be negative")
      .required("Dispensers count is required"),
    staff_vaccinators: Yup.number()
      .typeError("Vaccinators count must be a required")
      .max(999, "Value cannot exceed 999")
      .min(0, "Value cannot be negative")
      .required("Vaccinators count is required"),
    staff_others: Yup.string().required("Other staff is required"),
    date_of_collection: Yup.date()
      .nullable()
      .required("Date of Data Collection is required"),
    latitude: Yup.number()
      .typeError("Latitude must be a number")
      .required("Latitude is required"),

    longitude: Yup.number()
      .typeError("Longitude must be a number")
      .required("Longitude is required"),

    health_status: Yup.string().required("Health Status is required"),
    facility_type: Yup.string().required("Facility Type is required"),
    facility_type_other: Yup.string().when("facility_type", {
      is: "Others",
      then: (schema) => schema.required("Please specify other facility type"),
      otherwise: (schema) => schema.notRequired(),
    }),
    ownership: Yup.string().required("Ownership is required"),
    ownership_other: Yup.string().when("ownership", {
      is: "Other",
      then: (schema) => schema.required("Please specify other ownership"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  useEffect(() => {
    if (healthFacility) {
      const doctors = parseInt(healthFacility?.number_of_doctors || 0, 10);
      const lhvs = parseInt(healthFacility?.number_of_lhvs || 0, 10);
      const dispensers = parseInt(
        healthFacility?.number_of_dispensers || 0,
        10
      );
      const vaccinators = parseInt(
        healthFacility?.number_of_vaccinators || 0,
        10
      );
      const others = parseInt(healthFacility?.health_staff_other || 0, 10);

      setFormData((prev) => ({
        ...prev,
        facility_name: healthFacility?.name_of_health_facility || "",
        incharge_name: healthFacility?.incharge_name || "",
        incharge_contact: healthFacility?.incharge_contact || "",
        facility_contact: healthFacility?.facility_contact || "",
        facility_type: healthFacility?.health_facility_type || "",
        facility_type_other: healthFacility?.health_facility_type_other || "",
        pharmacy: healthFacility?.pharmacy_available ? "Yes" : "No",
        ownership: healthFacility?.health_ownership || "",
        ownership_other: healthFacility?.health_ownership_others || "",
        functional: healthFacility?.health_functional ? "Yes" : "No",
        staff_doctors: healthFacility?.number_of_doctors ?? "",
        staff_lhvs: healthFacility?.number_of_lhvs ?? "",
        staff_dispensers: healthFacility?.number_of_dispensers ?? "",
        staff_vaccinators: healthFacility?.number_of_vaccinators ?? "",
        staff_others: healthFacility?.health_staff_other || "",
        date_of_collection: healthFacility.date_of_data_collection
          ? dayjs(healthFacility.date_of_data_collection)
          : null,
        health_status:
          healthFacility?.health_status === 1 ||
          healthFacility?.health_status === "Yes" ||
          healthFacility?.health_status === "Functional"
            ? "Functional"
            : "Non Functional",
        mission: healthFacility?.mission || "",
        latitude: healthFacility?.latitude || "",
        longitude: healthFacility?.longitude || "",
        total_staff: doctors + lhvs + dispensers + vaccinators + others,
        uc_name: healthFacility?.uc_name || healthFacility?.uc || "", // try uc_name, fallback
      }));

      setSelectedDistrict(String(healthFacility?.district_id || ""));
      setSelectedTaluka(String(healthFacility?.tehsil_id || ""));
      setSelectedDeh(String(healthFacility?.deh_id || ""));
      setSelectedVillage(String(healthFacility?.village_id || ""));
    }
  }, [healthFacility]);

  useEffect(() => {
    const loadDistricts = async () => {
      try {
        const res = await fetchData("districts");
        setDistricts(res?.data || []);
      } catch {
        toast.error("Failed to fetch districts");
      }
    };
    loadDistricts();
  }, []);

  useEffect(() => {
    if (!selectedDistrict) return setTehsils([]);
    const loadTehsils = async () => {
      try {
        const res = await fetchData(`tehsils?district_id=${selectedDistrict}`);
        setTehsils(res?.data || []);
      } catch {
        toast.error("Failed to fetch tehsils");
      }
    };
    loadTehsils();
  }, [selectedDistrict]);

  useEffect(() => {
    if (!selectedTaluka) return setDehs([]);
    const loadDehs = async () => {
      try {
        const res = await fetchData(`dehs?tehsil_id=${selectedTaluka}`);
        setDehs(res?.data || []);
      } catch {
        toast.error("Failed to fetch dehs");
      }
    };
    loadDehs();
  }, [selectedTaluka]);

  useEffect(() => {
    if (!selectedDeh) return setVillages([]);
    const loadVillages = async () => {
      try {
        const res = await fetchData(`villages?deh_id=${selectedDeh}`);
        setVillages(res?.data || []);
      } catch {
        toast.error("Failed to fetch villages");
      }
    };
    loadVillages();
  }, [selectedDeh]);



  useEffect(() => {
    const fetchLocationData = async () => {
      try {
        const [districtRes, tehsilRes, ucRes, dehRes, villageRes] =
          await Promise.all([
            fetchData("districts"),
            fetchData("tehsils"),
            fetchData("ucs"),
            fetchData("dehs"),
            fetchData("villages"),
          ]);

        setDistricts(districtRes?.data || []);
        setTehsils(tehsilRes?.data || []);
        setUcs(ucRes?.data || []);
        setDehs(dehRes?.data || []);
        setVillages(villageRes?.data || []);
      } catch (error) {
        toast.error("Error loading location data");
      }
    };

    fetchLocationData();
  }, []);

  const districtOptions = districts.map((d) => ({
    value: String(d.district_id),
    label: d.district_name,
  }));

  const talukaOptions = tehsils
    .filter(
      (t) => !selectedDistrict || t.district_id.toString() === selectedDistrict
    )
    .map((t) => ({ value: String(t.tehsil_id), label: t.tehsil_name }));
 const ucOptions = ucs.map((u) => ({
    value: String(u.uc_id),
    label: u.uc_name,
  }));
  const dehOptions = dehs
    .filter((d) => !selectedTaluka || d.tehsil_id.toString() === selectedTaluka)
    .map((d) => ({ value: String(d.deh_id), label: d.deh_name }));

  const villageOptions = villages
    .filter((v) => !selectedDeh || v.deh_id.toString() === selectedDeh)
    .map((v) => ({ value: String(v.village_id), label: v.village_name }));
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const healthStatusOptions = [
    { label: "Functional", value: "Functional" },
    { label: "Non Functional", value: "Non Functional" },
  ];

  const handleNumericChange = (field, value) => {
    if (value === "" || (/^\d+$/.test(value) && parseInt(value, 10) <= 999)) {
      setFormData((prev) => {
        const updatedForm = {
          ...prev,
          [field]: value,
        };

        const staffOthersCount = /^\d+$/.test(updatedForm.staff_others)
          ? parseInt(updatedForm.staff_others, 10)
          : 0;

        const total =
          parseInt(updatedForm.staff_doctors || 0, 10) +
          parseInt(updatedForm.staff_lhvs || 0, 10) +
          parseInt(updatedForm.staff_dispensers || 0, 10) +
          parseInt(updatedForm.staff_vaccinators || 0, 10) +
          staffOthersCount;

        updatedForm.total_staff = total;

        return updatedForm;
      });

      if (errors[field]) {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[field];
          return newErrors;
        });
      }
    }
  };
  const handleLocationChange = (setter, field, value) => {
    setter(value);

    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }

    if (field === "district_id") {
      setSelectedTaluka("");
      setSelectedDeh("");
      setSelectedVillage("");
      setFormData((prev) => ({ ...prev, mission: "" }));
    } else if (field === "tehsil_id") {
      setSelectedDeh("");
      setSelectedVillage("");
      setFormData((prev) => ({ ...prev, mission: "" }));
    } else if (field === "deh_id") {
      setSelectedVillage("");
      setFormData((prev) => ({ ...prev, mission: "" }));
    }
  };

  const handleUpdate = async () => {
    setIsUpdating(true);
    setErrors({});

    try {
      const validationData = {
        ...formData,
        district_id: selectedDistrict,
        tehsil_id: selectedTaluka,
        uc_name: formData.uc_name,
        deh_id: selectedDeh,
        village_id: selectedVillage,
      };

      await validationSchema.validate(validationData, { abortEarly: false });

      const updatePayload = {
        name_of_health_facility: formData.facility_name,
        incharge_name: formData.incharge_name,
        incharge_contact: formData.incharge_contact,
        facility_contact: formData.facility_contact,
        health_facility_type: formData.facility_type,
        health_facility_type_other: formData.facility_type_other || null,
        pharmacy_available: formData.pharmacy === "Yes" ? 1 : 0,
        health_ownership: formData.ownership,
        health_ownership_others: formData.ownership_other || null,
        health_functional: formData.functional === "Yes" ? 1 : 0,
        number_of_doctors: parseInt(formData.staff_doctors, 10) || 0,
        number_of_lhvs: parseInt(formData.staff_lhvs, 10) || 0,
        number_of_dispensers: parseInt(formData.staff_dispensers, 10) || 0,
        number_of_vaccinators: parseInt(formData.staff_vaccinators, 10) || 0,
        health_staff_other: formData.staff_others || "",
        district_id: selectedDistrict,
        tehsil_id: selectedTaluka,
        uc_name: formData.uc_name || null,
        deh_id: selectedDeh,
        village_id: selectedVillage,
        health_status: formData.health_status,
        latitude: formData.latitude,
        longitude: formData.longitude,
        date_of_data_collection: formData.date_of_collection
          ? formData.date_of_collection.format("YYYY-MM-DD")
          : null,
        latitude: parseFloat(formData.latitude) || 0,
        longitude: parseFloat(formData.longitude) || 0,
        health_status:
          formData.health_status === "Functional"
            ? "Functional"
            : "Non-Functional",
        mission: formData.mission || null,
      };

      const response = await fetchData(
        `health-facility-update/${healthFacility.health_facility_id}`,
        "PUT",
        { health_facility: updatePayload },
        { "Content-Type": "application/json" }
      );

      if (response && response.success) {
        toast.success("Health Facility updated successfully!");
      } else {
        toast.error(response?.message || "Update failed!");
      }
    } catch (error) {
      if (error.inner) {
        const newErrors = {};
        error.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
        setErrors(newErrors);
      } else {
        console.error("Update error:", error);
        toast.error("Update failed");
      }
    } finally {
      setIsUpdating(false);
    }
  };

  const facilityTypes = [
    { label: "BHU", value: "BHU" },
    { label: "RHC", value: "RHC" },
    { label: "Government Dispensary", value: "Government Dispensary" },
    { label: "MCH Center", value: "MCH Center" },
    { label: "Family Health Clinic", value: "Family Health Clinic" },
    { label: "Private Clinic", value: "Private Clinic" },
    { label: "NGO Clinic/Mobile Clinic", value: "NGO Clinic/Mobile Clinic" },
    { label: "LHW Program", value: "LHW Program" },
    { label: "THQ", value: "THQ" },
    { label: "DHQ", value: "DHQ" },
    {
      label: "Charitable Hospital (Secondary Level)",
      value: "Charitable Hospital (Secondary Level)",
    },
    { label: "Others", value: "Others" },
  ];

  const pharmacyOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  const ownershipOptions = [
    { label: "Government", value: "Government" },
    { label: "Private", value: "Private" },
    { label: "NGO", value: "NGO" },
    { label: "PPHI", value: "PPHI" },
    { label: "Others", value: "Others" },
  ];

  const functionalOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        {isDqaApproved && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              General Information
            </h2>
            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
              Approved from DQA
            </span>
          </>
        )}
        {isDqaRejected && (
          <>
            <h2 className="text-teal-700 text-xl font-semibold">
              General Information
            </h2>
            <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
              Rejected from DQA
            </span>
          </>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="District"
            options={districtOptions}
            value={selectedDistrict}
            onChange={(value) =>
              handleLocationChange(setSelectedDistrict, "district_id", value)
            }
          />
          {errors.district_id && (
            <p className="text-red-500 text-xs">{errors.district_id}</p>
          )}
        </div>

        <div>
          <ThinDropdownWithSearch
            label="Taluka"
            options={talukaOptions}
            value={selectedTaluka}
            onChange={(value) =>
              handleLocationChange(setSelectedTaluka, "tehsil_id", value)
            }
            disabled={!selectedDistrict || isDqaApproved || isDqaRejected}
          />
          {errors.tehsil_id && (
            <p className="text-red-500 text-xs">{errors.tehsil_id}</p>
          )}
        </div>
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Union Council"
            value={formData.uc_name}
            onChange={(e) => handleChange("uc_name", e.target.value)}
            placeholder="Enter UC name"
            isRequired={false}
          />
          {/* {errors.uc_name && (
            <p className="text-red-500 text-xs">{errors.uc_name}</p>
          )} */}
        </div>

        <div>
          <ThinDropdownWithSearch
            label="Deh"
            options={dehOptions}
            value={selectedDeh}
            onChange={(value) =>
              handleLocationChange(setSelectedDeh, "deh_id", value)
            }
            disabled={!selectedTaluka || isDqaApproved || isDqaRejected}
          />
          {errors.deh_id && (
            <p className="text-red-500 text-xs">{errors.deh_id}</p>
          )}
        </div>

        <div>
          <ThinDropdownWithSearch
            label="Mission"
            options={missionOptions}
            value={formData.mission}
            onChange={(value) => handleChange("mission", value)}
            disabled={!selectedDeh || isDqaApproved || isDqaRejected}
          />
          {errors.mission && (
            <p className="text-red-500 text-xs">{errors.mission}</p>
          )}
          {!selectedDeh && (
            <p className="text-gray-500 text-xs mt-1">
              Please select a Deh first
            </p>
          )}
        </div>

        <div>
          <ThinDropdownWithSearch
            label="Village"
            options={villageOptions}
            value={selectedVillage}
            onChange={(value) =>
              handleLocationChange(setSelectedVillage, "village_id", value)
            }
            disabled={!selectedDeh || isDqaApproved || isDqaRejected}
          />
          {errors.village_id && (
            <p className="text-red-500 text-xs">{errors.village_id}</p>
          )}
        </div>
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Name of Health Facility (HF)"
            value={formData.facility_name}
            onChange={(e) => handleChange("facility_name", e.target.value)}
          />
          {errors.facility_name && (
            <p className="text-red-500 text-xs">{errors.facility_name}</p>
          )}
        </div>

        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Name of Incharge / Administrator"
            value={formData.incharge_name}
            onChange={(e) => handleChange("incharge_name", e.target.value)}
          />
          {errors.incharge_name && (
            <p className="text-red-500 text-xs">{errors.incharge_name}</p>
          )}
        </div>
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Facility Contact"
            value={formData.facility_contact}
            onChange={(e) => {
              let input = e.target.value.replace(/\D/g, "");
              if (input.length > 4) {
                input = input.slice(0, 4) + "-" + input.slice(4, 11);
              }
              setFormData((prev) => ({ ...prev, facility_contact: input }));
            }}
          />
          {errors.facility_contact && (
            <p className="text-red-500 text-xs">{errors.facility_contact}</p>
          )}
        </div>
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Incharge Contact"
            value={formData.incharge_contact}
            onChange={(e) => {
              let input = e.target.value.replace(/\D/g, "");
              if (input.length > 4) {
                input = input.slice(0, 4) + "-" + input.slice(4, 11);
              }
              setFormData((prev) => ({ ...prev, incharge_contact: input }));
            }}
          />
          {errors.incharge_contact && (
            <p className="text-red-500 text-xs">{errors.incharge_contact}</p>
          )}
        </div>
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Type of Health Facility"
            options={facilityTypes}
            value={formData.facility_type}
            onChange={(val) => handleChange("facility_type", val)}
          />
          {errors.facility_type && (
            <p className="text-red-500 text-xs">{errors.facility_type}</p>
          )}
        </div>
        {formData.facility_type === "Others" && (
          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Specify Other Facility Type"
              value={formData.facility_type_other}
              onChange={(e) =>
                handleChange("facility_type_other", e.target.value)
              }
            />
            {errors.facility_type_other && (
              <p className="text-red-500 text-xs">
                {errors.facility_type_other}
              </p>
            )}
          </div>
        )}
        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Status of Health Facility"
            options={healthStatusOptions}
            value={formData.health_status}
            onChange={(val) => handleChange("health_status", val)}
          />
          {errors.health_status && (
            <p className="text-red-500 text-xs">{errors.health_status}</p>
          )}
        </div>

        <div>
          <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
            label="Ownership"
            options={ownershipOptions}
            value={formData.ownership}
            onChange={(val) => handleChange("ownership", val)}
          />
          {errors.ownership && (
            <p className="text-red-500 text-xs">{errors.ownership}</p>
          )}
        </div>
        {formData.ownership === "Others" && (
          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Specify Other Ownership"
              value={formData.ownership_other}
              onChange={(e) => handleChange("ownership_other", e.target.value)}
            />
            {errors.ownership_other && (
              <p className="text-red-500 text-xs">{errors.ownership_other}</p>
            )}
          </div>
        )}
        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Latitude"
            type="number"
            value={formData.latitude}
            onChange={(e) => handleChange("latitude", e.target.value)}
          />
          {errors.latitude && (
            <p className="text-red-500 text-xs">{errors.latitude}</p>
          )}
        </div>

        <div>
          <ThinTextField disabled={isDqaApproved || isDqaRejected}
            label="Longitude"
            type="number"
            value={formData.longitude}
            onChange={(e) => handleChange("longitude", e.target.value)}
          />
          {errors.longitude && (
            <p className="text-red-500 text-xs">{errors.longitude}</p>
          )}
        </div>
        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Date of Data Collection *"
              value={formData.date_of_collection}
              onChange={(newVal) => handleChange("date_of_collection", newVal)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  error: !!errors.date_of_collection,
                },
              }}
              format="DD/MM/YYYY"
              disabled
              maxDate={dayjs()}
            />
          </LocalizationProvider>
          {errors.date_of_collection && (
            <p className="text-red-500 text-xs mt-1">
              {errors.date_of_collection}
            </p>
          )}
        </div>
        {formData.health_status === "Functional" && (
          <>
            <h1 className="col-span-3 font-semibold text-lg mt-4 mb-2">
              Number of Staff at the Health Facilities
            </h1>
            <div>
              <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
                label="Pharmacy Available"
                options={pharmacyOptions}
                value={formData.pharmacy}
                onChange={(val) => handleChange("pharmacy", val)}
              />
              {errors.pharmacy && (
                <p className="text-red-500 text-xs">{errors.pharmacy}</p>
              )}
            </div>

            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="No. of Staff (Doctors)"
                type="number"
                value={formData.staff_doctors}
                onChange={(e) =>
                  handleNumericChange("staff_doctors", e.target.value)
                }
              />
              {errors.staff_doctors && (
                <p className="text-red-500 text-xs">{errors.staff_doctors}</p>
              )}
            </div>

            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="No. of Staff (LHVs)"
                type="number"
                value={formData.staff_lhvs}
                onChange={(e) =>
                  handleNumericChange("staff_lhvs", e.target.value)
                }
              />
              {errors.staff_lhvs && (
                <p className="text-red-500 text-xs">{errors.staff_lhvs}</p>
              )}
            </div>

            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="No. of Staff (Dispensers)"
                type="number"
                value={formData.staff_dispensers}
                onChange={(e) =>
                  handleNumericChange("staff_dispensers", e.target.value)
                }
              />
              {errors.staff_dispensers && (
                <p className="text-red-500 text-xs">
                  {errors.staff_dispensers}
                </p>
              )}
            </div>

            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="No. of Staff (Vaccinators)"
                type="number"
                value={formData.staff_vaccinators}
                onChange={(e) =>
                  handleNumericChange("staff_vaccinators", e.target.value)
                }
              />
              {errors.staff_vaccinators && (
                <p className="text-red-500 text-xs">
                  {errors.staff_vaccinators}
                </p>
              )}
            </div>

            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label=" Others Staff "
                type="text"
                value={formData.staff_others}
                onChange={(e) => handleChange("staff_others", e.target.value)}
              />
              {errors.staff_others && (
                <p className="text-red-500 text-xs">{errors.staff_others}</p>
              )}
            </div>

            <div>
              <ThinTextField
                label="Total Staff"
                type="number"
                value={formData.total_staff}
                disabled
              />
            </div>
          </>
        )}
      </div>
      {!isDqaApproved && !isDqaRejected ? (
        <div className="mt-8 flex justify-end">
          <button
            type="button"
            onClick={handleUpdate}
            disabled={isUpdating}
            className={`${
              isUpdating
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-teal-600 hover:bg-teal-700"
            } text-white px-4 py-2 rounded-lg transition duration-200 font-medium`}
          >
            {isUpdating ? "Updating..." : "Update"}
          </button>
        </div>
      ) : (
        <div className=""></div>
      )}
    </>
  );
};

export default GeneralInformation;
